import React, { Component } from 'react';
import { Button, Dropdown, Icon } from 'semantic-ui-react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import ControlsRenderer from '../../components/custom_controls_renderer'
import { connect } from 'react-redux';
import { updateRisk } from '../../actions/risk'

class PlanTable extends Component {
  constructor(props){
    super(props);
    this.likelihoodOptions = [{
      value: '1 (Rare)',
      label: '1 (Rare)'
    }, {
      value: '2 (Unlikely)',
      label: '2 (Unlikely)'
    }, {
      value: '3 (Possible)',
      label: '3 (Possible)'
    }, {
      value: '4 (Likely)',
      label: '4 (Likely)'
    }, {
      value: '5 (Almost Certain)',
      label: '5 (Almost Certain)'
    }];

    this.consequencesOptions = [{
      value: '',
      label: 'None'
    }, {
      value: '1',
      label: '1'
    }, {
      value: '2',
      label: '2'
    }, {
      value: '3',
      label: '3'
    }, {
      value: '4',
      label: '4'
    }, {
      value: '5',
      label: '5'
    }];

    this.planColumns = [
      {
        dataField: 'activity',
        text: 'Activity',
        formatter: this.cellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerStyle: {
          width: '110px'
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'step_and_hazard',
        text: 'Step & Hazard linked',
        formatter: this.cellFormatter,
        editor: {
          type: Type.TEXTAREA
        },
        headerTitle: true,
        title: true,
        editCellClasses: 'textarea-style',
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'preventative',
        text: 'Preventative Controls',
        formatter: (cell, row)=>this.controlsCellFormatter(cell, row, this.props.planId),
        headerTitle: true,
        headerStyle: {
          width: '400px'
        },
        editable: false,
        hidden: false,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'recovery',
        text: 'Recovery Controls',
        headerTitle: true,
        editCellClasses: 'textarea-style',
        editable: false,
        hidden: false,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'consequences_description',
        text: 'Consequence Description',
        formatter: this.cellFormatter,
        editCellClasses: 'textarea-style',
        editor: {
          type: Type.TEXTAREA
        },
        headerTitle: (column, colIndex) => `Description of Potential Unwanted Consequences`,
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'likelihood',
        text: 'Likelihood',
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.likelihoodOptions
        },
        headerStyle: {
          width: '80px'
        },
        headerTitle: (column, colIndex) => 'Likelihood of Hazardous Condition being realized (independent of consequence e.g. likelihood of vehicle collision )',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'safety',
        text: 'S', //Safety
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.consequencesOptions
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Safety',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'health',
        text: 'H', //Health
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.consequencesOptions
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Health',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'environmental_impact',
        text: 'E', //'Environment'
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.consequencesOptions
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Environmental Impact',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'business_interuption',
        text: 'BI', //'Business Interruption'
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.consequencesOptions
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Business Interruption Material Damage',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'legal_and_regulatory',
        text: 'L', //'Legal'
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.consequencesOptions
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Legal & Regulatory',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
      {
        dataField: 'social_community',
        text: 'R', //'Reputation'
        formatter: this.cellFormatter,
        editor: {
          type: Type.SELECT,
          options: this.consequencesOptions
        },
        headerStyle: {
          width: '40px'
        },
        headerTitle: (column, colIndex) => 'Social Community / Reputation Impact',
        title: true,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
       },
      {
        dataField: 'highest_rating',
        text: 'Highest Risk Rating',  //'Highest Risk Rating'
        formatter: this.cellFormatter,
        headerStyle: {
          width: '85px'
        },
        headerTitle: (column, colIndex) => 'Highest Risk Rating',
        title: true,
        editable: false,
        sort: true,
        headerFormatter: (column, colIndex, { filterElement }) => this.headerFormatter(column, filterElement, this.props.sortBy)
      },
    ];
  }

  componentWillUpdate(nextProps, nextState){
    if (nextProps.searchFieldsShown){
      this.addFilterFields();
    }
    else {
      this.removeFilterFields();
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if (nextProps.shouldNotRender){
      return false;
    }
    else {
      return true;
    }
  }

  cellFormatter(cell, row) {
    return (
     <div className='cell-style'>
      { cell }
     </div>
    );
  }

  controlsCellFormatter(cell, row, planId) {
    return <ControlsRenderer value={cell} planId={planId} riskId={row.id} setTagOptions={this.setTagOptions.bind(this)} isRiskHidden={row.hidden}/>
  }

  headerFormatter(column, filterElement, sortBy) {
    return (
      <div style={ { display: 'flex', flexDirection: 'column' } }>
        { column.text }
        { sortBy != null && sortBy.field === column.dataField && this.sortIcon(sortBy.order) }
        { filterElement }
      </div>
    );
  }

  sortIcon(order) {
     if(order.toUpperCase() === 'ASC') {
       return <div className='sort-icon-div'><Icon name='angle up'/>ASC</div>
     }
     else {
       return <div className='sort-icon-div'><Icon name='angle down'/>DESC</div>
     }
  }

  toggleControls(hide) {
    this.planColumns[2].hidden = hide;
    this.planColumns[3].hidden = hide;
  }

  updateRisk(oldValue, newValue, row, column, object){
    if (oldValue === newValue) {
      return;
    }

    if (column.dataField === 'likelihood' && (newValue==='' || newValue===null)){
      row[column.dataField] = oldValue
      return;
    }
    var likelihood = row.likelihood.split('(')
    let metadata = {
      activity: row.activity,
      consequences_description: row.consequences_description,
      linked_to_hazard: row.linked_to_hazard,
      highest_rating: row.highest_rating,
      step_and_hazard: row.step_and_hazard,
      consequences: [
        {
          key: 'safety',
          value: row.safety
        },
        {
          key: 'health',
          value: row.health
        },
        {
          key: 'environmental_impact',
          value: row.environmental_impact
        },
        {
          key: 'business_interuption',
          value: row.business_interuption
        },
        {
          key: 'legal_and_regulatory',
          value: row.legal_and_regulatory
        },
        {
          key: 'social_community',
          value: row.social_community
        },
      ],
      likelihood: {
        type: likelihood[1].replace(')', ''),
        value: likelihood[0].replace(' ', '')
      }
    }
    let risk = {
      id: row.id,
      metadata: JSON.stringify(metadata)
    };
    this.props.updateRisk(this.props.planId, risk, newValue, row);
  }

  handleRiskColumns(oldValue, newValue, row, column, object){
    //execute validations here
  }

  addFilterFields(){
    for (var i in this.planColumns){
      this.planColumns[i].filter = textFilter();
    }
  }

  removeFilterFields(){
    for (var i in this.planColumns){
      delete this.planColumns[i].filter;
    }
  }

  setTagOptions(tag){
    this.props.setTagOptions(tag);
  }

  tableHeader(hiddenRisksShown, showHiddenRisks) {
    if(!hiddenRisksShown) {
      return ''
    }

    var headerText = 'Select Applicable activities'
    var buttonText = 'Hide unselected activities'

    return (
      <div>
        <div className="plan-title ui header">{headerText}</div>
        <div className="toggle-button-div">
          <Button color='blue' fluid size='medium' onClick={() => showHiddenRisks(!hiddenRisksShown)} className="toggle-activities-button"><i className="eye slash alternate icon"></i>{buttonText}</Button>
        </div>
      </div>
    )
  }

  onTableChange = (type, newState) => {
    if(type === 'sort') {
      var sortBy = {
        field: newState.sortField,
        order: newState.sortOrder
      }
      this.props.setSortBy(sortBy)
    }
    else if(type === 'filter') {
      var columnName = Object.getOwnPropertyNames(newState.filters)[0];
      this.props.setColumnName(columnName);
      if (newState.filters[columnName]){
        var searchTerm = newState.filters[columnName]['filterVal'];
        this.props.setSearchTerm(searchTerm);
      }
      else {
        this.props.setSearchTerm('');
      }
    }
    this.props.loadPlan();
  }

  render() {
    const { risks, selectRow, hiddenRisksShown, showHiddenRisks } = this.props;

    //Hide/Uhide controls
    this.toggleControls(hiddenRisksShown)
    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    const TableHeader = () => this.tableHeader(hiddenRisksShown, showHiddenRisks)

    return (
      <BootstrapTable
        remote={ {
          filter: true,
          sort: true
        } }
        onTableChange={ this.onTableChange }
        tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
        keyField="id"
        data={ risks }
        columns={ this.planColumns }
        cellEdit={ cellEditFactory({
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: (oldValue, newValue, row, column, object) => this.handleRiskColumns(oldValue, newValue, row, column, this),
            afterSaveCell: (oldValue, newValue, row, column, object) => this.updateRisk(oldValue, newValue, row, column, this)
          })
        }
        striped
        hover
        condensed
        noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>No Risks have been selected.</span>}
        defaultChecked={ false }
        selectRow={ selectRow }
        filter={ filterFactory() }
        caption={<TableHeader />}
        defaultSorted={ defaultSorted }
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    updateSuccess: state.risk.updateSuccess,
    pending: state.risk.pending,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRisk: (plan_id, risk, cellValue, row) => {
      dispatch(updateRisk(plan_id, risk, cellValue, row))
    },
  }
}

let PlanTableView = connect(mapStateToProps, mapDispatchToProps)(PlanTable)
export default PlanTableView;



// WEBPACK FOOTER //
// ./src/views/plan_tables/plan_table.js